/**
 * Function to access global configurations
 *
 * @param key Config item key
 * @param fallback Default value if key does not exist
 */
export default function (key, fallback) {
    if (fallback === void 0) { fallback = null; }
    return window.CONFIG[key] || fallback;
}
